@if (records.length) {
<mat-paginator
  [length]="totalResults"
  (page)="changePage($event)"
  [pageSize]="pageSize"
  [pageIndex]="currentPageIndex"
  [pageSizeOptions]="pageSizeOptions"
>
</mat-paginator>
<div class="data-table-container">
  <div class="data-table-wrapper">
    <table [dataSource]="records" class="mat-elevation-z2" mat-table aria-describedby="data-table-container">
      <ng-container [matColumnDef]="columns.treatmentCenter">
        <th mat-header-cell *matHeaderCellDef class="wrap-conent">
          {{ headers.treatmentCenter }}
        </th>
        <td class="wrap-content" mat-cell *matCellDef="let record">
          <stx-simple-report-cell
            [rowInputs]="[record.treatmentCenter, record.country, record.province, record.district]"
          ></stx-simple-report-cell>
        </td>
      </ng-container>
      <ng-container [matColumnDef]="columns.patient">
        <th mat-header-cell *matHeaderCellDef>
          {{ headers.patient }}
        </th>
        <td mat-cell *matCellDef="let record">
          <div class="align-middle flex-row-container">
            <stx-patient-link [showIcon]="false" [patientId]="record.patientId">
              <stx-simple-report-cell [rowInputs]="[record.hospitalRecordId]"></stx-simple-report-cell>
            </stx-patient-link>
            <stx-patient-link [patientHistoryRoute]="true" [patientId]="record.patientId"> </stx-patient-link>
          </div>
          <stx-simple-report-cell
            [rowInputs]="[record.hospitalRecordIdLoc, record.patientName, record.patientLocalName, record.patientId]"
            [inlineInputsToTranslate]="[record.gender]"
            [inlineInputs]="[record.dateOfBirth]"
          ></stx-simple-report-cell>
        </td>
      </ng-container>
      <ng-container [matColumnDef]="columns.speechAssessment">
        <th mat-header-cell *matHeaderCellDef>
          {{ headers.speechAssessment }}
        </th>
        <td mat-cell *matCellDef="let record">
          <stx-treatment-status-indicator
            [addBottomPadding]="true"
            [showLabel]="false"
            [treatmentStatus]="record.status"
          ></stx-treatment-status-indicator>
          <div>
            <a
              [routerLink]="
                record.assessmentDate ? speechAssessmentBaseUrl + record.businessId : speechTreatmentBaseUrl + record.businessId
              "
              [queryParams]="{ patientId: record.patientId }"
            >
              <!--  Available only in user selects Speech assesment option in filters -->
              @if (record.assessmentDate) {
              {{ record.assessmentDate }} <br />
              }
              <!--  Available only in user selects Speech treatment option in filters -->
              @if (record.reportDate) {
              {{ record.reportDate }} <br />
              } @if (record.speechTreatmentFrom) {
              {{ record.speechTreatmentFrom }}
              } @if (record.speechTreatmentFrom && record.speechTreatmentTo) { &nbsp;&mdash;&nbsp; } @if (record.speechTreatmentTo) {
              {{ record.speechTreatmentTo }}
              }
            </a>
            <stx-treatment-date class="bold" [direction]="'column'" [submitDate]="record.recordSubmitted"></stx-treatment-date>
          </div>
        </td>
      </ng-container>
      @if (!!columns.speechStage) {
      <ng-container [matColumnDef]="columns.speechStage">
        <th mat-header-cell *matHeaderCellDef>
          {{ headers.speechStage }}
        </th>
        <td class="wrap-content" mat-cell *matCellDef="let record">
          {{ record.speechStage | translate }}
        </td>
      </ng-container>
      }
      <ng-container [matColumnDef]="columns.speechPractitioner">
        <th mat-header-cell *matHeaderCellDef>
          {{ headers.speechPractitioner }}
        </th>
        <td mat-cell *matCellDef="let record">
          <stx-simple-report-cell
            [rowInputs]="[record.speechPractitioner | localName : record.speechPractitionerLoc]"
          ></stx-simple-report-cell>
        </td>
      </ng-container>
      <ng-container [matColumnDef]="columns.recommendations">
        <th mat-header-cell *matHeaderCellDef>
          {{ headers.recommendations }}
        </th>
        <td class="wrap-content" mat-cell *matCellDef="let record">
          @for (reccomendation of record.recommendations; track reccomendation; let isLast = $last) {
          {{ reccomendation | translate }}
          @if (isReevaluateIn(reccomendation)) {
          {{ record.recommendReevalMonths }} {{ 'speech_assessment.recommend_reevaluate_in_months' | translate }}
          } @if (isLast) { @if (record.recommendOther) {
          <stx-value-separator></stx-value-separator>
          {{ record.recommendOther }}
          } @if (record.recommendComment) {
          <stx-value-separator></stx-value-separator>
          {{ record.recommendComment }}
          } } @if (!isLast) {
          <stx-value-separator></stx-value-separator>
          } }
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columnsList"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsList" class="table-row"></tr>
    </table>
  </div>
</div>
<mat-paginator
  [length]="totalResults"
  (page)="changePage($event)"
  [pageSize]="pageSize"
  [pageIndex]="currentPageIndex"
  [pageSizeOptions]="pageSizeOptions"
>
</mat-paginator>
} @if (reportTableDataService.dataReady && !records.length) {
<div>
  <stx-empty-table-state></stx-empty-table-state>
</div>
}
